var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RightBottomContainer"},[_c('ContentTop',{attrs:{"title":"体育场地设施数量排行","topOptionsProps":_vm.cityActiveOptionProps,"type":2}}),_c('div',{staticClass:"rank-list",staticStyle:{"margin-top":"23px"}},[_c('rank-list',{attrs:{"listHeight":334,"tableTitle":_vm.tableTitle,"list":_vm.areaData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }